import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import routes from '../../../../router/routes'
import Text from '../../../../components/text/Text'
import { InvoiceStylesStyles } from './InvoiceStyles'
import { getDataInvoice } from '../../../../services/amipos'
import { currencyFormat, getCurrentDateTime } from '../../../../formatters'

export function InvoiceComponent() {
    const navigation = useNavigate()

    const [data, setData] = useState({
        current: {
            month: '',
            amount: '0',
        },
        last: {
            month: '',
            amount: '0',
        },
    })

    useEffect(() => {
        getDataInvoice()
            .then(async (success) => {
                setData({
                    current: {
                        month: success.data.currentMonth,
                        amount: success.data.saleCurrentMonth,
                    },
                    last: {
                        month: success.data.lastMonth,
                        amount: success.data.saleLastMonth,
                    },
                })
            })
            .catch((error) => {
                alert('ERR')
                console.log(error)
            })
    }, [])

    const handleHistory = () => {
        navigation(`/${routes.sales}/${routes.salesDetails}`)
    }

    const handleInvoice = () => {
        navigation(`/${routes.billing}`)
    }

    return (
        <div style={InvoiceStylesStyles.container}>
            <div style={InvoiceStylesStyles.titleContainer}>
                <div style={InvoiceStylesStyles.titleContent}>
                    <div style={InvoiceStylesStyles.dot} />
                    <div>
                        <Text
                            color="#fff"
                            fontSize={12}
                            fontWeight={400}
                            label={`Fecha última actualización: ${getCurrentDateTime()}`}
                        />
                    </div>
                </div>
            </div>
            <div style={InvoiceStylesStyles.itemContainer}>
                <Text label={`Ventas ${data.last.month}`} color="#656565" />
                <Text
                    label={`${currencyFormat(parseFloat(data.last.amount))}`}
                    fontWeight={600}
                    color={
                        !isNaN(Number(data.last.amount)) &&
                        Number(data.last.amount) < 0
                            ? 'red'
                            : '#656565'
                    }
                />
            </div>
            <div style={InvoiceStylesStyles.itemContainer}>
                <Text label="Ventas Actuales" color="#656565" />
                <Text
                    label={`${currencyFormat(parseFloat(data.current.amount))}`}
                    fontWeight={600}
                    color={
                        !isNaN(Number(data.current.amount)) &&
                        Number(data.current.amount) < 0
                            ? 'red'
                            : '#656565'
                    }
                />
            </div>
            <div style={InvoiceStylesStyles.btnContainer}>
                <button
                    onClick={handleHistory}
                    style={InvoiceStylesStyles.btnHistory}
                >
                    <Text
                        label="Ver Historial"
                        fontWeight={600}
                        color="#ffff"
                    />
                </button>
                <button
                    onClick={handleInvoice}
                    style={InvoiceStylesStyles.btnInvoice}
                >
                    <Text label="Facturar" fontWeight={600} color="#ffff" />
                </button>
            </div>
        </div>
    )
}
